import React from 'react';
import { RefreshCw, RotateCcw } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface RetryButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
  version?: '1' | '2';
}

export const RetryButton: React.FC<RetryButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  className,
  children = 'Retry',
  version = '1',
}) => {
  if (version === '2') {
    return (
      <button 
        onClick={onClick}
        disabled={disabled || isLoading}
        className={cn(
          "inline-flex items-center justify-center gap-2 mt-2 px-4 py-2 text-white",
          "text-sm font-bold rounded-md",
          "focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
          "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-100",
          "transition-colors duration-200",
          "bg-[linear-gradient(135deg,#788AF7_0%,#3551F3_100%)]",
          className
        )}
      >
        <RotateCcw className={cn("h-4 w-4", isLoading && "animate-spin")} />
        {children}
      </button>
    );
  };

  return (
    <button 
      onClick={onClick}
      disabled={disabled || isLoading}
      className={cn(
        "inline-flex items-center justify-center gap-2 mt-2 px-4 py-2",
        "text-sm font-bold rounded-full",
        "bg-blue-100 text-blue-800",
        "hover:bg-blue-200",
        "focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
        "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-100",
        "transition-colors duration-200",
        className
      )}
    >
      <RefreshCw className={cn("h-4 w-4", isLoading && "animate-spin")} />
      {children}
    </button>
  );
};